export default __webpack_public_path__ + "static/media/tag2Icon.15c4b20f.svg";